import { render, staticRenderFns } from "./EfsMdContractPriceChangeModal.vue?vue&type=template&id=70ce3e3a&"
import script from "./EfsMdContractPriceChangeModal.vue?vue&type=script&lang=js&"
export * from "./EfsMdContractPriceChangeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports